var render = function render(){var _vm=this,_c=_vm._self._c;return _c('overlay-scrollbars',_vm._b({ref:_vm.uuid,class:[
    _vm.uuid,
    _vm.baseClass,
    _vm.allowDrag ? (_vm.active ? 'cursor-grabbing select-none' : 'cursor-grab') : 'cursor-default'
  ],nativeOn:{"mousedown":function($event){return _vm.mouseDownHandler.apply(null, arguments)},"mousemove":function($event){return _vm.mouseMoveHandler.apply(null, arguments)},"mouseup":function($event){return _vm.mouseUpHandler.apply(null, arguments)}}},'overlay-scrollbars',_vm.props,false),[_c('div',{class:_vm.containerClass},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }